

















export default
	props: article: Object

	computed:
		category: -> @article?.category?[0]?.title

		articleURL: -> "/" + @article?.uri

